/**
 * The "space › room" line under a viewer's title, as navigable links.
 *
 * Since #130 (2026-04-30, Sváťa's Apr 11 feedback) both the transcript and the
 * screen viewer show which space and room a service belongs to. That change
 * was about *context*, so it rendered plain text. The header then read as a
 * hierarchy while the only thing in it you could click — the back arrow —
 * went to the room: the space was named and unreachable. MU QA (Natálie,
 * checklist 26.–28. 8.) hit exactly that. Each segment now links to its own
 * page.
 */
/** The space's own page. */
export function viewerSpacePath(spaceId) {
    return `/spaces/${encodeURIComponent(spaceId)}`;
}
/**
 * The room's own page. The viewers build every room link through this — a
 * breadcrumb crumb, a back arrow, an error state's way out — so they cannot
 * disagree for an id carrying a URL-significant character. Pages that list
 * rooms they already hold ids for still build their own paths.
 */
export function viewerRoomPath(spaceId, roomId) {
    return `${viewerSpacePath(spaceId)}/rooms/${encodeURIComponent(roomId)}`;
}
/** Space first, then room — the order the header reads. */
export function viewerBreadcrumb(room) {
    return [
        { label: room.spaceName, href: viewerSpacePath(room.spaceId) },
        { label: room.name, href: viewerRoomPath(room.spaceId, room.id) },
    ];
}
/**
 * Narrow a room to one the breadcrumb can render, or null.
 *
 * Every field is load-bearing: a missing id or spaceId makes a crumb
 * unaddressable, and a missing *name* is worse than useless — it renders as a
 * focusable link with no accessible text (WCAG 2.4.4 / 4.1.2). Callers that
 * resolve a room asynchronously must render nothing until this returns a room.
 */
export function viewerBreadcrumbRoom(room) {
    if (!room)
        return null;
    const { id, name, spaceId, spaceName } = room;
    if (!id || !name || !spaceId || !spaceName)
        return null;
    return { id, name, spaceId, spaceName };
}
//# sourceMappingURL=viewer-breadcrumb.js.map